// frontend/src/features/ogdb2/components/BAIDSearchPanel.jsx
import React from "react";

export default function BAIDSearchPanel({
  busy,
  client,
  setClient,
  taxYear,
  setTaxYear,
  q,
  setQ,
  rrc,
  setRrc,
  leaseName,
  setLeaseName,
  operator,
  setOperator,
  county,
  setCounty,
  externalAccountId,
  setExternalAccountId,
  interestType,
  setInterestType,
  limit,
  setLimit,
  sort,
  setSort,
  onSearch,
}) {
  return (
    <section className="rounded-2xl border border-gray-200 bg-white p-4">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="text-sm font-semibold text-gray-800">BAID Search</div>
        <div className="flex items-center gap-2">
          <button className="btn" type="button" disabled={busy} onClick={onSearch}>
            Search
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <label className="text-xs text-gray-700">
          Client <span className="text-red-600">*</span>
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={client}
            onChange={(e) => setClient(e.target.value)}
            placeholder="e.g. Eagle Ridge"
            disabled={busy}
          />
        </label>

        <label className="text-xs text-gray-700">
          Tax Year (optional)
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={taxYear}
            onChange={(e) => setTaxYear(e.target.value)}
            placeholder="2025"
            disabled={busy}
          />
        </label>

        <label className="text-xs text-gray-700">
          Limit
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={String(limit)}
            onChange={(e) => setLimit(e.target.value)}
            placeholder="200"
            disabled={busy}
          />
        </label>

        <label className="text-xs text-gray-700 md:col-span-3">
          Free text (matches well/lease/operator/etc)
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Try: 'wardlaw', 'karnes', 'eagle', '12345'…"
            disabled={busy}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch?.();
            }}
          />
        </label>

        <label className="text-xs text-gray-700">
          RRC #
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={rrc}
            onChange={(e) => setRrc(e.target.value)}
            placeholder="e.g. 123456"
            disabled={busy}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch?.();
            }}
          />
        </label>

        <label className="text-xs text-gray-700">
          Lease Name
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={leaseName}
            onChange={(e) => setLeaseName(e.target.value)}
            placeholder="e.g. Johnson Unit"
            disabled={busy}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch?.();
            }}
          />
        </label>

        <label className="text-xs text-gray-700">
          Operator
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={operator}
            onChange={(e) => setOperator(e.target.value)}
            placeholder="e.g. EOG"
            disabled={busy}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch?.();
            }}
          />
        </label>

        <label className="text-xs text-gray-700">
          County
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={county}
            onChange={(e) => setCounty(e.target.value)}
            placeholder="e.g. Karnes"
            disabled={busy}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch?.();
            }}
          />
        </label>

        <label className="text-xs text-gray-700">
          External Account / Lease #
          <input
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={externalAccountId}
            onChange={(e) => setExternalAccountId(e.target.value)}
            placeholder="e.g. LeaseNumber"
            disabled={busy}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch?.();
            }}
          />
        </label>

        <label className="text-xs text-gray-700">
          Interest Type
          <select
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={interestType}
            onChange={(e) => setInterestType(e.target.value)}
            disabled={busy}
          >
            <option value="">(any)</option>
            <option value="WI">WI</option>
            <option value="RI">RI</option>
            <option value="NRI">NRI</option>
          </select>
        </label>
      </div>

      <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
        <label className="text-xs text-gray-700">
          Sort
          <select
            className="mt-1 w-full rounded-lg border border-gray-200 bg-white p-2 text-sm"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            disabled={busy}
          >
            <option value="updated_at_desc">Updated (newest)</option>
            <option value="updated_at_asc">Updated (oldest)</option>
            <option value="rrc_asc">RRC (A→Z)</option>
            <option value="rrc_desc">RRC (Z→A)</option>
          </select>
        </label>

        <div className="flex items-end justify-end gap-2">
          <button className="btn" type="button" disabled={busy} onClick={onSearch}>
            Search BAIDs
          </button>
        </div>
      </div>
    </section>
  );
}
